import { useEffect, useState } from "react";
import { Form } from "antd";

import { GET } from "../../../../providers/useAxiosQuery";
import FormContent from "./FormContent";
import FormCollapseItem from "./FormCollapseItem";
import PageScoreCardFormContext from "./PageScoreCardFormContext";
import FormContentSend from "./FormContentSend";

export default function PageScoreCardFormContent(props) {
	const { isSendMyScoreCard, setIsSendMyScoreCard } = props;

	const [form] = Form.useForm();
	const [isLoadingSurveyList, setIsLoadingSurveyList] = useState(true);
	const [toggleModalPreview, setToggleModalPreview] = useState(false);
	const [dataSource, setDataSource] = useState(null);
	const [dataQuestions, setDataQuestions] = useState([]);
	const [dataQuestionCategory, setDataQuestionCategory] = useState([]);
	const [answers, setAnswers] = useState(
		localStorage.getItem("scorecardAnswers")
			? JSON.parse(localStorage.getItem("scorecardAnswers"))
			: {}
	);

	const [collapseActiveKey, setCollapseActiveKey] = useState(["0"]);
	const [collapseItems, setCollapseItems] = useState([]);
	const [graphResult, setGraphResult] = useState([]);
	const [checkError, setCheckError] = useState(false);
	const [lastActiveTab, setLastActiveTab] = useState(null);

	GET(`api/formsur?from=Scorecard`, "formsur_scorecard_form", async (res) => {
		if (res && res.data) {
			let data = res.data;
			let findForm = data[0];

			if (findForm) {
				setDataSource(findForm);
				setDataQuestionCategory(findForm.form_question_categories);
				setDataQuestions(
					findForm.form_question_categories.reduce((acc, category) => {
						return acc.concat(category.form_questions);
					}, [])
				);

				handleStepItems(findForm.form_question_categories);
			}

			setIsLoadingSurveyList(false);
		}
	});

	const handleStepItems = (data) => {
		let formValues = {};
		let items = [];

		let categoryIds = [];
		data.forEach((item, index) => {
			let form_questions = item.form_questions || [];

			form_questions.forEach((question) => {
				if (question.form_question_options) {
					question.form_question_options.forEach((option) => {
						if (option.form_question_category_id) {
							categoryIds.push(option.form_question_category_id);
						}
					});
				}

				if (question.question_type === "Rating") {
					formValues[`q_${question.id}`] = 0;
				}
			});

			let hidden = false;
			let hasshow = false;

			let excludeHidden = ["For Not Working Option", "For Single Option"]; // default show these category ids
			if (categoryIds.length && !excludeHidden.includes(item.notes)) {
				if (categoryIds.includes(item.id)) {
					hidden = true;
					hasshow = true;
				}
			}

			let attachment = null;

			if (item?.attachments && item.attachments.length) {
				attachment = item.attachments[0];
			}

			items.push({
				key: index.toString(),
				label: item.category,
				children: (
					<FormCollapseItem
						index={index}
						catDescription={item.description}
						catAttachment={attachment}
						dataQuestion={item.form_questions}
					/>
				),
				data: item,
				hidden,
				hasshow,
			});
		});

		form.setFieldsValue(formValues);
		setCollapseItems(items);
	};

	const onFinish = (values) => {
		if (!checkError) {
			let newAnswers = { ...answers, ...values };

			let newCategory = [];

			dataQuestionCategory.forEach((item) => {
				let countAnswered = 0;

				item.form_questions.forEach((question) => {
					let questionId = question.id;
					let answer = newAnswers[`q_${questionId}`];
					if (answer) {
						question.form_question_options.forEach((option) => {
							if (answer === option.option) {
								// check if number option.scale
								if (!isNaN(Number(option.scale))) {
									countAnswered += Number(option.scale);
								}
							}
						});
					}
				});

				newCategory.push({
					name: item.category,
					y: 100 / dataQuestionCategory.length,
					z: countAnswered,
				});
			});

			setGraphResult(newCategory);
			setIsSendMyScoreCard(true);
		}
	};

	const onValuesChange = (changedValues, allValues) => {
		let allAnswers = { ...answers, ...allValues };

		// console.log("changedValues: ", changedValues);
		// console.log("allValues: ", allValues);

		let q_1 = allValues["q_1"];
		let q_2 = allValues["q_2"];

		let collapseItemsCopy = [...collapseItems];

		if (q_1) {
			if (q_1 === "Working") {
				collapseItemsCopy[1] = {
					...collapseItemsCopy[1],
					hidden: false,
				};
				collapseItemsCopy[2] = {
					...collapseItemsCopy[2],
					hidden: true,
				};
				let questions = collapseItemsCopy[2].data.form_questions.reduce(
					(acc, question) => {
						acc[`q_${question.id}`] = null;
						return acc;
					},
					{}
				);
				console.log("questions: ", questions);
				// remove key and value from allAnswers that are in questions
				Object.keys(allAnswers).forEach((key) => {
					if (questions[key] !== undefined) {
						delete allAnswers[key];
					}
				});
			} else if (q_1 === "Not Working") {
				collapseItemsCopy[1] = {
					...collapseItemsCopy[1],
					hidden: true,
				};
				collapseItemsCopy[2] = {
					...collapseItemsCopy[2],
					hidden: false,
				};
				let questions = collapseItemsCopy[1].data.form_questions.reduce(
					(acc, question) => {
						acc[`q_${question.id}`] = null;
						return acc;
					},
					{}
				);
				console.log("questions: ", questions);
				// remove key and value from allAnswers that are in questions
				Object.keys(allAnswers).forEach((key) => {
					if (questions[key] !== undefined) {
						delete allAnswers[key];
					}
				});
			}
		}

		if (q_2) {
			if (q_2 === "Single") {
				collapseItemsCopy[3] = {
					...collapseItemsCopy[3],
					hidden: true,
				};
				collapseItemsCopy[4] = {
					...collapseItemsCopy[4],
					hidden: false,
				};
				let questions = collapseItemsCopy[3].data.form_questions.reduce(
					(acc, question) => {
						acc[`q_${question.id}`] = null;
						return acc;
					},
					{}
				);
				console.log("questions: ", questions);
				// remove key and value from allAnswers that are in questions
				Object.keys(allAnswers).forEach((key) => {
					if (questions[key] !== undefined) {
						delete allAnswers[key];
					}
				});
			} else if (q_2 === "In A Relationship") {
				collapseItemsCopy[3] = {
					...collapseItemsCopy[3],
					hidden: false,
				};
				collapseItemsCopy[4] = {
					...collapseItemsCopy[4],
					hidden: true,
				};
				let questions = collapseItemsCopy[4].data.form_questions.reduce(
					(acc, question) => {
						acc[`q_${question.id}`] = null;
						return acc;
					},
					{}
				);
				console.log("questions: ", questions);
				// remove key and value from allAnswers that are in questions
				Object.keys(allAnswers).forEach((key) => {
					if (questions[key] !== undefined) {
						delete allAnswers[key];
					}
				});
			}
		}

		setCollapseItems(collapseItemsCopy);

		localStorage.setItem("scorecardAnswers", JSON.stringify(allAnswers));

		setAnswers(allAnswers);

		let questionId = Object.keys(changedValues)[0].split("q_")[1];
		let q_answer = changedValues[`q_${questionId}`];

		if (questionId && Number(questionId) === 2) {
			localStorage.setItem("scorecardRelationship", q_answer);
		}

		// let question = dataQuestions.find((item) => item.id === Number(questionId));
		// if (question) {
		// 	let form_question_options = question.form_question_options || [];

		// 	form_question_options.forEach((option) => {
		// 		let collapseItemCopy = collapseItems;

		// 		if (option.option === q_answer) {
		// 			let findCollapseItemIndex = collapseItemCopy.findIndex(
		// 				(item) => item.data.id === option.form_question_category_id
		// 			);
		// 			if (findCollapseItemIndex !== -1) {
		// 				collapseItemCopy[findCollapseItemIndex] = {
		// 					...collapseItemCopy[findCollapseItemIndex],
		// 					hidden: false,
		// 				};
		// 			}
		// 		} else {
		// 			let findCollapseItemIndex = collapseItemCopy.findIndex(
		// 				(item) => item.data.id === option.form_question_category_id
		// 			);
		// 			if (findCollapseItemIndex !== -1) {
		// 				collapseItemCopy[findCollapseItemIndex] = {
		// 					...collapseItemCopy[findCollapseItemIndex],
		// 					hidden: true,
		// 				};
		// 			}
		// 		}
		// 		setCollapseItems(collapseItemCopy);
		// 	});
		// }
	};

	useEffect(() => {
		if (!isLoadingSurveyList) {
			let scorecardAnswers = localStorage.getItem("scorecardAnswers")
				? JSON.parse(localStorage.getItem("scorecardAnswers"))
				: null;

			if (scorecardAnswers) {
				// search for q_1 and q_2 to set collapseActiveKey
				let q_1 = scorecardAnswers["q_1"];
				let q_2 = scorecardAnswers["q_2"];

				let collapseItemCopy = [...collapseItems];
				if (q_1) {
					if (q_1 === "Working") {
						collapseItemCopy[1] = {
							...collapseItemCopy[1],
							hidden: false,
						};
						collapseItemCopy[2] = {
							...collapseItemCopy[2],
							hidden: true,
						};
					} else if (q_1 === "Not Working") {
						collapseItemCopy[1] = {
							...collapseItemCopy[1],
							hidden: true,
						};
						collapseItemCopy[2] = {
							...collapseItemCopy[2],
							hidden: false,
						};
					}
				}

				if (q_2) {
					if (q_2 === "Single") {
						collapseItemCopy[3] = {
							...collapseItemCopy[3],
							hidden: true,
						};
						collapseItemCopy[4] = {
							...collapseItemCopy[4],
							hidden: false,
						};
					} else if (q_2 === "In A Relationship") {
						collapseItemCopy[3] = {
							...collapseItemCopy[3],
							hidden: false,
						};
						collapseItemCopy[4] = {
							...collapseItemCopy[4],
							hidden: true,
						};
					}
				}

				let lastActiveTab = null;
				if (dataQuestions.length > 0) {
					let lastAnsweredQuestionId = null;

					Object.keys(scorecardAnswers).forEach((key) => {
						let qid = Number(key.replace("q_", ""));
						if (scorecardAnswers[key]) {
							lastAnsweredQuestionId = qid;
						}
					});

					let lastAnsweredQuestion = dataQuestions.find(
						(q) => q.id === lastAnsweredQuestionId
					);
					if (lastAnsweredQuestion) {
						let lastCategoryId = lastAnsweredQuestion.form_question_category_id;
						let lastCategoryIndex = collapseItemCopy.findIndex(
							(item) => item.data.id === lastCategoryId
						);
						if (lastCategoryIndex !== -1) {
							lastActiveTab = lastCategoryIndex.toString();
							setLastActiveTab(lastActiveTab);
							setCollapseActiveKey([lastActiveTab]);
						}
					}
				}

				setCollapseItems(collapseItemCopy);

				form.setFieldsValue(scorecardAnswers);

				// find last active tab
			}
		}

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoadingSurveyList]);

	return (
		<PageScoreCardFormContext.Provider
			value={{
				form,
				onFinish,
				onValuesChange,
				collapseItems,
				dataSource,
				answers,
				setAnswers,
				collapseActiveKey,
				setCollapseActiveKey,
				toggleModalPreview,
				setToggleModalPreview,
				graphResult,
				setCheckError,
				dataQuestions,
				lastActiveTab,
				setLastActiveTab,
				isLoadingSurveyList,
			}}
		>
			{!isSendMyScoreCard ? <FormContent /> : <FormContentSend />}
		</PageScoreCardFormContext.Provider>
	);
}
